import { render } from "./DocumentsReglementairesTab.vue?vue&type=template&id=3c546bfa&scoped=true&ts=true"
import script from "./DocumentsReglementairesTab.vue?vue&type=script&lang=ts"
export * from "./DocumentsReglementairesTab.vue?vue&type=script&lang=ts"

import "./DocumentsReglementairesTab.vue?vue&type=style&index=0&id=3c546bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c546bfa"]])

export default __exports__